import React from "react";
import { useFormatCurrency } from "../common/format-currency";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return date.toLocaleDateString("en-GB", options); // Format as "17 Aug 2024"
};

const CartItem = ({
  item,
  onIncrease,
  onDecrease,
  isSoldOut,
  isPurchaseDatePassed,
  currency,
  maxTicketPerUser,
}) => {
  const { formatCurrency } = useFormatCurrency();
  const salesEndDate = item.salesEndDate ? formatDate(item.salesEndDate) : null;

  return (
    <div
      className={`cart-item ${isSoldOut ? "sold-out" : ""} ${
        isPurchaseDatePassed ? "purchase-date-passed" : ""
      }`}
    >
      <div className="cart-item-header">
        <h3>{item.name}</h3>
        <div className="quantity-controls">
          <button
            onClick={() => onDecrease(item._id)}
            disabled={
              item.cartQuantity <= 0 || isSoldOut || isPurchaseDatePassed
            }
          >
            -
          </button>
          <span>{item.cartQuantity}</span>
          <button
            onClick={() => onIncrease(item._id)}
            disabled={
              item.cartQuantity >= maxTicketPerUser ||
              isSoldOut ||
              isPurchaseDatePassed
            }
          >
            +
          </button>
        </div>
      </div>
      <p className="cart-price">
        {item.amount === 0 ? "Free" : formatCurrency(item.amount, currency)}
      </p>
      {salesEndDate && (
        <p className="sales-end-date">Sales end on {salesEndDate}</p>
      )}
      {isSoldOut && <p className="status-text">Sold Out</p>}
      {isPurchaseDatePassed && (
        <p className="status-text">Purchase Date Passed</p>
      )}
    </div>
  );
};

export default CartItem;
